<template>
  <form action='/download-document' class='tenant-form' :name='formId' :id='formId' method='post' target='_blank'>
    <div class='tenant-form__heading'></div>
    <input name='_token' type='hidden' :value='token'>
    <input name='propertyId' type='hidden' :value='property'>
    <input name='landlordId' type='hidden' :value='landlord'>
    <input name='subscriptionId' type='hidden' :value='subscription'>
    <input name='documentId' type='hidden' :value='document'>
    <div class='tenant-form__documents mb-7' v-if='allowSigned'>
      <div class='tenant-form__documents-heading'>{{ selectSignedCheckbox }}</div>
      <div class='tenant-form__documents-inner'>
        <template v-for='(tenantBlock, tenantIndex) in tenantInfo'>
          <div
            class='tenant-form__documents-row'
            v-for='(checkboxSigned, checkboxIndex) in tenantBlock.signedCheckboxList'
          >
            <label class='tenant-form__checkbox'>
              <input
                type='checkbox'
                :name="'fileId[]'"
                :value='checkboxSigned.id'
                :id="formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
                :disabled='checkboxSigned.disabled'
                :checked='checkboxSigned.value'
                @change='checkboxSigned.value = !checkboxSigned.value'
              />
              <div class='tenant-form__checkbox-indicator'></div>
              <span class='tenant-form__checkbox-label' v-if="!checkboxSigned.disabled && checkboxSigned.filename && checkboxSigned.filename.slice(-3).toLowerCase()==='pdf'">
                <a
                  :title='checkboxSigned.imageName'
                  :href='checkboxSigned.imageUrl'
                  class='tenant-form__gallery-link'
                  :data-rel="'lightcase:myCollection' + formId"
                >{{ checkboxSigned.checkboxText }}</a>
              </span>
              <span class='tenant-form__checkbox-label' v-else-if='!checkboxSigned.disabled'>
                <a
                  :title='checkboxSigned.imageName'
                  :href="'#box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
                  class='tenant-form__gallery-link'
                  :data-rel="'lightcase:myCollection' + formId"
                >{{ checkboxSigned.checkboxText }}</a>
              </span>
              <span class='tenant-form__checkbox-label' v-else>
                <span class='tenant-form__checkbox-info'>
                  <span>{{ checkboxSigned.checkboxText }}</span>
                  <div class='tenant-form__checkbox-info-inner'>
                    <i class='icon-eye' @click='showTenantTooltip'/>
                    <span class='tenant-form__checkbox-info-text' @click='showTenantTooltip'>
                      {{ checkboxSigned.reason }}
                    </span>
                    <span class='tenant-form__tooltip'>
                        <div class='tenant-form__tooltip-overlay' @click='closeTenantTooltip'></div>
                        <div class='tenant-form__tooltip-box'>
                          <div class='icon-close tenant-form__tooltip-close-icon' @click='closeTenantTooltip'></div>
                          <div class='tenant-form__tooltip-text'>{{ checkboxSigned.reasonFullText }}</div>
                        </div>
                      </span>
                  </div>
                </span>
              </span>
              <div class='absolute'>
                <v-lightcase-holder
                  :image-src='checkboxSigned.imageUrl'
                  :name="'box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex + '-signed'"
                  :current-document='checkboxSigned'
                  :disable-rotate='true'>
                </v-lightcase-holder>
              </div>
            </label>
          </div>
        </template>
      </div>
    </div>
    <div class='tenant-form__tenant-box' v-for='(tenantBlock, tenantIndex) in tenantInfo'>
      <strong class='tenant-form__subtitle'>{{ tenantBlock.text }}</strong>
      <div v-if="tenantBlock.showExtraInformation && tenantBlock.extraInformations && tenantBlock.extraInformations != ''" class="mb-5">
        <div><strong>{{ locales && locales.common && locales.common.extra_informations }}</strong></div>
        <div><em v-html='tenantBlock.extraInformations'></em></div>
      </div>
      <div v-if='tenantBlock.checkboxList && tenantBlock.checkboxList.length' class='tenant-form__documents'>
        <div class='tenant-form__documents-heading'>Documents</div>
        <div class='tenant-form__documents-inner'>
          <div class='tenant-form__documents-row' v-for='(checkbox, checkboxIndex) in tenantBlock.checkboxList'>
            <label class='tenant-form__checkbox'>
              <input
                type='checkbox'
                :name="'fileId[]'"
                :value='checkbox.id'
                :id="formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
                :disabled='checkbox.disabled'
                :checked='checkbox.value'
                @change='checkbox.value = !checkbox.value'
              />
              <div class='tenant-form__checkbox-indicator'></div>
              <span class='tenant-form__checkbox-label' v-if="!checkbox.disabled && checkbox.filename && checkbox.filename.slice(-3).toLowerCase()==='pdf'">
                <a
                  :title='checkbox.imageName'
                  :href='checkbox.imageUrl'
                  class='tenant-form__gallery-link'
                  :data-rel="'lightcase:myCollection' + formId"
                >{{ checkbox.checkboxText }}</a>
              </span>
              <span class='tenant-form__checkbox-label' v-else-if='!checkbox.disabled'>
                <a
                  :title='checkbox.imageName'
                  :href="'#box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
                  class='tenant-form__gallery-link'
                  :data-rel="'lightcase:myCollection' + formId"
                >{{ checkbox.checkboxText }}</a>
              </span>
              <span class='tenant-form__checkbox-label' v-else>
                <span class='tenant-form__checkbox-info'>
                  <span>{{ checkbox.checkboxText }}</span>
                  <div class='tenant-form__checkbox-info-inner'>
                    <i class='icon-eye' @click='showTenantTooltip'/>
                    <span class='tenant-form__checkbox-info-text' @click='showTenantTooltip'>
                      {{ checkbox.reason }}
                    </span>
                    <span class='tenant-form__tooltip'>
                        <div class='tenant-form__tooltip-overlay' @click='closeTenantTooltip'></div>
                        <div class='tenant-form__tooltip-box'>
                          <div class='icon-close tenant-form__tooltip-close-icon' @click='closeTenantTooltip'></div>
                          <div class='tenant-form__tooltip-text'>{{ checkbox.reasonFullText }}</div>
                        </div>
                      </span>
                  </div>
                </span>
              </span>
              <div class='absolute'>
                <v-lightcase-holder
                  :image-src='checkbox.imageUrl'
                  :name="'box-' + formId + '-' + 'checkbox-' + tenantIndex + '-' + checkboxIndex"
                  :current-document='checkbox'
                  :disable-rotate='true'>
                </v-lightcase-holder>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div v-else style='color:#ccc;'>No documents</div>
    </div>
    <div class='tenant-form__footer'>
      {{ downloadText }}:
      <input
        class='theme-btn theme-btn--small theme-btn--secondary'
        :class="{'theme-btn--secondary-disabled': !isSomeCheckboxChecked}"
        type='submit'
        name='type'
        value='PDF'
        title='Save as pdf'
        :disabled='!isSomeCheckboxChecked'
      >
      <input
        class='theme-btn theme-btn--small theme-btn--secondary'
        :class="{'theme-btn--secondary-disabled': !isSomeCheckboxChecked}"
        type='submit'
        name='type'
        value='ZIP'
        title='Save as zip'
        :disabled='!isSomeCheckboxChecked'
      >
      <input
        class='theme-btn theme-btn--small theme-btn--secondary'
        :class="{'theme-btn--secondary-disabled': !isSomeCheckboxChecked}"
        type='submit'
        name='type'
        value='PRINT'
        title='Print'
        @click.prevent='print'
        :disabled='!isSomeCheckboxChecked'
      >
      <div>
        <label :for='selectAllId' class='tenant-form__checkbox' @change='setStateToAllCheckboxes'>
          <input type='checkbox' :name='selectAllId' :id='selectAllId'>
          <div class='tenant-form__checkbox-indicator'></div>
          <span class='tenant-form__checkbox-label'>{{ selectAllCheckbox }}</span>
        </label>
      </div>
    </div>
  </form>
</template>
<script>
  import MobileDetect from 'mobile-detect/mobile-detect';
  import 'lightcase/src/css/lightcase.css';
  import configurePublicLightcase from '../public-lightcase.js';
  import VLightcaseHolder from '../admin/components/VLightcaseHolder.vue';
  import {mapGetters} from 'vuex';

  window.MobileDetect = MobileDetect;

  export default {
    components: {
      VLightcaseHolder,
    },
    data() {
      return {
        allCheckboxesState: false,
      };
    },
    computed: {
      ...mapGetters(['locales']),
      formId: function() {
        return 'tenant-form-' + this.id;
      },
      selectAllId: function() {
        return 'select-all-' + this.id;
      },
      isSomeCheckboxChecked: function() {
        var info = null;
        for (var i = 0; i < this.tenantInfo.length; i++) {
          info = this.tenantInfo[i];
          for (var y = 0; y < info.checkboxList.length; y++) {
            if (!info.checkboxList[y].disabled) {
              if (info.checkboxList[y].value === true) return true;
            }
          }
          if (info.signedCheckboxList !== undefined) {
            for (var y = 0; y < info.signedCheckboxList.length; y++) {
              if (!info.signedCheckboxList[y].disabled) {
                if (info.signedCheckboxList[y].value === true) return true;
              }
            }
          }
        }
        return false;
      },
    },
    props: {
      id: {
        default: '',
        type: Number,
      },
      subscription: {
        default: '',
        type: String,
      },
      property: {
        default: '',
        type: String,
      },
      landlord: {
        default: '',
        type: String,
      },
      document: {
        default: '',
        type: String,
      },
      allowSigned: {
        default: 0,
        type: Number,
      },
      selectAllCheckbox: {
        default: '',
        type: String,
      },
      selectSignedCheckbox: {
        default: '',
        type: String,
      },
      tenantInfo: {
        default: () => [],
        type: Array,
      },
      downloadText: {
        default: '',
        type: String,
      },
      token: {
        default: '',
        type: String,
      },
    },
    methods: {
      showTenantTooltip: function(event) {
        const parent = event.target.parentNode;
        const sibling = parent.querySelector('.tenant-form__tooltip');
        this.closeTenantTooltip();
        sibling.classList.add('tenant-form__tooltip_active');
      },
      closeTenantTooltip: function() {
        $('.tenant-form__tooltip_active').removeClass(
          'tenant-form__tooltip_active',
        );
      },
      setStateToAllCheckboxes: function() {
        var info = null;
        if (!this.allCheckboxesState) {
          for (var i = 0; i < this.tenantInfo.length; i++) {
            info = this.tenantInfo[i];
            for (var y = 0; y < info.checkboxList.length; y++) {
              if (!info.checkboxList[y].disabled) {
                info.checkboxList[y].value = true;
              }
            }
          }
          this.allCheckboxesState = true;
        } else {
          for (var i = 0; i < this.tenantInfo.length; i++) {
            info = this.tenantInfo[i];
            for (var y = 0; y < info.checkboxList.length; y++) {
              info.checkboxList[y].value = false;
            }
          }
          this.allCheckboxesState = false;
        }
      },
      print: function(e) {
        let form = $('.tenant-form').first();
        let data = form.serialize();
        data = data + '&type=PRINT';
        $.ajax({
          url: form.attr('action'),
          method: 'post',
          data: data,
          success: function(result) {
            var w = window.open(result);
            if (navigator.appName == 'Microsoft Internet Explorer') {
              window.print();
            } else {
              w.print();
            }
          },
        });
      },
    },
    beforeMount() {
      configurePublicLightcase();
    },
    beforeUpdate() {
      configurePublicLightcase();
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/VTenantForm.vue